<template>
  <div>
    <base-section-title>#{{ $t("homepage.whoami.title")}}'</base-section-title>
    <article class="mt-5">
      <p v-html='$t("homepage.whoami.content")'></p>
    </article>
  </div>
</template>

<script>
import BaseSectionTitle from '../../base/BaseSectionTitle'

export default {
  name: 'WhoAmISection',
  components: { BaseSectionTitle }
}
</script>

<style scoped>

</style>
